export default "__VITE_ASSET__D8HhP5xE__"